import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
  hideImageOnMobile: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'ConfirmationStep',
})(({ brandColors, spacing, breakpoints, aspectRatio, typography }, props) => ({
  heading: {
    maxWidth: typography.pxToRem(390),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    [breakpoints.up('sm')]: {
      maxWidth: typography.pxToRem(539),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(627),
    },
    [breakpoints.up('xl')]: {
      maxWidth: typography.pxToRem(840),
    },
  },
  richTextParagraph: {
    margin: `${spacing(1)} 0 ${spacing(3)} 0`,
    maxWidth: '100%',
    [breakpoints.up('md')]: {
      margin: `${spacing(1)} 0 ${spacing(2)} 0`,
      maxWidth: typography.pxToRem(533),
    },
  },
  button: {
    minWidth: typography.pxToRem(142),
    marginBottom: spacing(3),
    [breakpoints.up('lg')]: {
      margin: 0,
    },
  },
  landerImage: {
    borderRadius: typography.pxToRem(16),
    width: '100%',
    objectFit: 'cover',
    aspectRatio: aspectRatio['4/3'],
    height: 'auto',
  },
  visible: {
    display: 'flex',
  },
  layout: {
    flexDirection: 'column',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  reverseLayout: {
    flexDirection: 'column-reverse',
    [breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
    },
  },
  hidden: {
    display: 'none',
  },
  reverseContent: {
    [breakpoints.up('md')]: {
      paddingLeft: spacing(3),
    },
  },
  hideImageOnMobile: {
    [breakpoints.down('md')]: {
      display: props.hideImageOnMobile ? 'none' : 'flex',
    },
  },
}));

export default useStyles;
